import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';

const API_VERSION = 'v2';

const response = {
    async postCompanyCreate(payload: any): Promise<any> {
        // name: string

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company`,
            payload,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async getCompanyByUuid(company_uuid: string): Promise<any> {
        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${company_uuid}`,
            undefined,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async getCompanyByProfileUuid(profile_uuid: string): Promise<any> {
        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/profile/${profile_uuid}`,
            undefined,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async getSiteDetailsByUuid(company_uuid: string, site_uuid: string): Promise<any> {
        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${company_uuid}/site/${site_uuid}`,
            undefined,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async deleteCompanyByUuid(company_uuid: string): Promise<any> {
        return await api(
            HTTP_TYPES.DELETE,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${company_uuid}`,
            undefined,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async getCompanySitesByUuid(company_uuid: string): Promise<any> {
        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${company_uuid}/sites`,
            undefined,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async getCompanySitesExportCSV(company_uuid: string): Promise<any> {
        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${company_uuid}/sites`,
            undefined,
            { export: true },
            'application/json',
            API_VERSION,
            {
                Accept: 'text/csv'
            }
        );
    },
    async getCompanySectorsByUuid(company_uuid: string): Promise<any> {
        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${company_uuid}/sectors`,
            undefined,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async getCompanySitesCount(company_uuid: string): Promise<any> {
        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/sites/${company_uuid}/count`,
            undefined,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async postSubscribeToCompany(uuid: string, payload: any): Promise<any> {
        // review_source: string

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${uuid}/sites`,
            payload,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async postUnsubscribeToCompany(uuid: string, payload: any): Promise<any> {
        // review_source: string

        return await api(
            HTTP_TYPES.DELETE,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${uuid}/sites`,
            payload,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async postRenameCompany(uuid: string, payload: any): Promise<any> {
        // name: string

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${uuid}/rename`,
            payload,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async postRenameSite(company_uuid: string, site_uuid: string, payload: any): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${company_uuid}/site/${site_uuid}/rename`,
            payload,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async postMergeSites(payload: any, company_uuid: string): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${company_uuid}/merge-sites`,
            payload,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async postCreateSite(company_uuid: string, payload: any): Promise<any> {
        // place_id: string
        // sector_uuid: guid

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${company_uuid}/site`,
            payload,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async postSiteAddPlaceId(company_uuid: string, site_uuid: string, payload: any): Promise<any> {
        // place_id: string

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/company/${company_uuid}/site/${site_uuid}/add-place-id`,
            payload,
            undefined,
            'application/json',
            API_VERSION
        );
    }
};

export default response;
